import React from "react";

import Tab from 'react/containers/layout/tabs/Tab';
import EventLogActionsCrud from "./EventLogHttpActionsCrud";
import EventLogCrud from "./EventLogCrud";
import EventLogGridHeader from "./EventLogGridHeader";

import { fixGridAndFilterBuilder } from "react/utils/utils";

class EventLog extends Tab {
  static tabName = "EventLog";

  state = {
    selectedGrid: 'EventLog'
  };

  componentDidUpdate(prevProps) {
    const { active } = this.props;
    const isComingFromAnotherTab = active !== prevProps.active;

    if (isComingFromAnotherTab && active) {
      fixGridAndFilterBuilder();
    }
  }

  toggleGrid = (value) => {
    this.setState({ selectedGrid: value });
  }

  render() {
    const { active } = this.props;
    const { selectedGrid } = this.state;
    const className = `gmTabs__panel ${active ? this.activeClassName : ""}`;

    return (
      <div className={className}>
        <div id={selectedGrid}>
          <EventLogGridHeader
            selectedGrid={selectedGrid}
            toggleGrid={this.toggleGrid}
          />
          {selectedGrid === 'EventLog' && (
            <EventLogCrud />
          )}
          {selectedGrid === 'EventLogHttpAction' && (
            <EventLogActionsCrud updateTitle={() => null} />
          )}
        </div>
      </div>
    );
  }
}


export default EventLog;
